import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 15H20M4 19H13M4 4.5H7M7 4.5H10M7 4.5V12" vectorEffect="non-scaling-stroke" />
	</SVG>
);
